/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React from 'react';
import Layout from '../../components/Layout';
import NotFound from './NotFound';
import ServicesLayout from '../../components/ServicesLayout';

const title = 'Page Not Found';

export default {

  path: '*',

  action() {
    return {
      title: 'Nie znaleziono zasobu',
      component: <ServicesLayout absoluteFooter><NotFound title={''} /></ServicesLayout>,
      status: 404,
    };
  },

};



// WEBPACK FOOTER //
// src/routes/notFound/index.js